export default __webpack_public_path__ + "static/staffy-footer-wordmark-566523e14c3e7a0de26ea321b44809a4.svg";